<template>
  <base-filter-expander :title="$t('search.Year')" :is-valid="isValid">
    <div :class="['year-select', { 'option-checked': isValid }]">
      <base-select
        :placeholder="$t('shared.from')"
        :options="fromOptions"
        :active="isActiveYearFrom"
        @update-store="updateMinYear($event)"
      />
      <base-select
        :placeholder="$t('shared.to')"
        :options="toOptions"
        :active="isActiveYearTo"
        @update-store="updateMaxYear($event)"
      />
    </div>
  </base-filter-expander>
</template>

<script>
import BaseFilterExpander from "@/components/ui/BaseFilterExpander/BaseFilterExpander.vue";
import BaseSelect from "@/components/ui/BaseSelect/BaseSelect.vue";
import { mapState } from "vuex";
import { UPDATE_YEAR } from "@/store/mutationTypes";
import { GET_DATA_FROM_API } from "@/store/actionTypes";
import { options } from "@/store/options";

export default {
  name: "YearSelect",
  components: {
    BaseFilterExpander,
    BaseSelect
  },
  computed: {
    ...mapState(["search"]),
    fromOptions() {
      return this.$store.getters.getYearRange.filter(
        year => year <= (this.search.year.to || options.year.to)
      );
    },
    toOptions() {
      return this.$store.getters.getYearRange.filter(
        year => year >= (this.search.year.from || options.year.from)
      );
    },
    isActiveYearFrom() {
      return this.search.year.from;
    },
    isActiveYearTo() {
      return this.search.year.to;
    },
    isValid() {
      return this.search.year.from !== this.search.year.to;
    }
  },
  methods: {
    updateMinYear(minYear) {
      this.$store.commit(UPDATE_YEAR, { type: "minimal", year: minYear });
      this.$store.dispatch(GET_DATA_FROM_API);
    },
    updateMaxYear(maxYear) {
      this.$store.commit(UPDATE_YEAR, { type: "maximal", year: maxYear });
      this.$store.dispatch(GET_DATA_FROM_API);
    }
  }
};
</script>

<style lang="scss" scoped>
.year-select {
  @include grid-columns(2);
  @include grid-ie11-fix(2);

  position: relative;

  &::before {
    @include absolute(top 50% left 50%);

    content: "";
    width: 2px;
    height: 20px;
    background-color: $color-white;
    transform: translate(-50%, -50%);
    z-index: $z-index-1;
  }

  &.option-checked::before {
    background-color: $color-blue-100;
  }

  &::after {
    @include absolute(top 50% left 50%);

    content: "-";
    transform: translate(-50%, -50%);
    z-index: $z-index-2;
  }
}

@media screen and (min-width: $media-m) {
  .year-select {
    width: 50%;
    margin: 0 auto;
  }
}

@media screen and (min-width: $media-l) {
  .year-select {
    width: $select-size-m;
  }
}

@media screen and (min-width: $media-xxl) {
  .year-select {
    width: $select-size-l;
  }
}
</style>
